import * as React from 'react';
import classNames from 'classnames';

import MPLink from '../MPLink';

interface IMainNavItem {
  className?: string;
  children?: React.ReactNode;
  iconName: string;
  activeIconName: string;
  to: string;
  currentPathname: string;
}

const MainNavItem: React.FunctionComponent<IMainNavItem> = ({
  className,
  children,
  to,
  iconName,
  activeIconName,
  currentPathname,
}) => {
  const isActive = currentPathname === to;

  const cn = classNames('MainNav-item', className, { isActive });

  return (
    <div className={cn}>
      <MPLink to={to} iconName={isActive ? activeIconName : iconName} isNavLink={true} exact={true}>
        {children}
      </MPLink>
    </div>
  );
};

export default React.memo(MainNavItem);



// WEBPACK FOOTER //
// ./src/components/MainHeader/MainNavItem.tsx